export default (str: string, len: number, padding: number = 0) => {
  const padArr = Array.apply(null, Array(len)); // eslint-disable-line prefer-spread
  const padStr = padArr.reduce((acc: string) => acc + padding, '');
  const realStr = str.toString();
  return padStr.substring(0, padStr.length - realStr.length) + realStr;
};
